"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttemptSerializer = void 0;
var models_1 = require("../../models");
var constants_1 = require("../../constants");
var item_response_1 = require("../../models/item-response");
var question_response_1 = require("../../models/question-response");
var feedback_model_1 = require("../../models/feedback.model");
/**
 * Serializes attempt
 *
 * @author javier.perez
 */
var AttemptSerializer = /** @class */ (function () {
    function AttemptSerializer(assessmentSerializer) {
        this.assessmentSerializer = assessmentSerializer;
    }
    AttemptSerializer.prototype.serialize = function (_a) {
        var _this = this;
        var id = _a.id, score = _a.score, startedAt = _a.startedAt, status = _a.status, assigneeId = _a.assigneeId, assessment = _a.assessment, maxScore = _a.maxScore, updatedAt = _a.updatedAt, closedAt = _a.closedAt, responses = _a.responses, feedback = _a.feedback, completedOnPaper = _a.completedOnPaper, graded = _a.graded, reopenedAt = _a.reopenedAt, noStudentSubmissionsFlow = _a.noStudentSubmissionsFlow;
        var assignee = assigneeId ? new models_1.User({ id: assigneeId }) : undefined;
        var serializedAssessment = assessment
            ? this.assessmentSerializer.serialize(assessment)
            : undefined;
        return new models_1.Attempt({
            id: id,
            score: score,
            startedAt: startedAt,
            closedAt: closedAt,
            updatedAt: updatedAt,
            status: status ? (0, constants_1.getAttemptStatusFrom)(status) : undefined,
            assignee: assignee,
            assessment: serializedAssessment,
            maxScore: maxScore,
            responses: responses ? responses.map(function (response) { return _this.serializeItemResponse(response); }) : [],
            feedback: feedback ? feedback.map(function (f) { return _this.serializeFeedback(f); }) : [],
            completedOnPaper: completedOnPaper,
            isGraded: graded,
            reopenedAt: reopenedAt,
            noStudentSubmissionsFlow: noStudentSubmissionsFlow,
        });
    };
    AttemptSerializer.prototype.serializeItemResponse = function (_a) {
        var _this = this;
        var externalItemId = _a.externalItemId, externalBankItemId = _a.externalBankItemId, responses = _a.responses, type = _a.type, score = _a.score, maxScore = _a.maxScore;
        return new item_response_1.ItemResponse({
            externalItemId: externalItemId,
            externalBankItemId: externalBankItemId,
            type: type,
            itemScore: score,
            itemMaxScore: maxScore,
            responses: responses
                ? responses.map(function (response) { return _this.serializeQuestionResponse(response); })
                : [],
        });
    };
    AttemptSerializer.prototype.serializeFeedback = function (_a) {
        var id = _a.id, itemExternalId = _a.itemExternalId, feedback = _a.feedback, createdBy = _a.createdBy;
        return new feedback_model_1.Feedback({
            id: id,
            itemExternalId: itemExternalId,
            feedback: feedback,
            createdBy: createdBy,
        });
    };
    AttemptSerializer.prototype.serializeQuestionResponse = function (_a) {
        var externalResponseId = _a.externalResponseId, externalQuestionId = _a.externalQuestionId, score = _a.score, answer = _a.answer, maxScore = _a.maxScore, attempted = _a.attempted;
        return new question_response_1.QuestionResponse({
            externalResponseId: externalResponseId,
            externalQuestionId: externalQuestionId,
            score: score,
            answer: answer,
            maxScore: maxScore,
            attempted: attempted,
        });
    };
    return AttemptSerializer;
}());
exports.AttemptSerializer = AttemptSerializer;
